module.exports = __webpack_public_path__ + "static/img/t-3-bg.5c4a6024.png";